<template>
    <div>
        <!--BEGIN-->
        <div class="form-group" v-if="(method == 'put')">
            <label>Cartella padre</label>
            <select v-model="data_parent_folder" class="form-control">
<!--                <option value="0">-->
<!--                    /-->
<!--                </option>-->
                <option v-for="folder in folders_array" :value="folder.id">
                    {{folder.name}}
                </option>
            </select>

        </div>
        <div class="form-group">
            <label>Nome Cartella</label>
            <input type="text" name="mediaStructure[name]" class="form-control" v-model="data_name_folder">
        </div>
        <div class="form-buttons">
            <button class="btn btn--green" type="button" @click="submitForm()">
                {{__("misc.save")}}
            </button>
        </div>
    </div>


</template>

<script>
    export default {
        mounted() {

            this.data_name_folder = this.name_folder;
            this.data_parent_folder = (this.parent_folder === null) ? 0 : this.parent_folder;

        },
        data () {
            return {
                data_name_folder : "",
                data_parent_folder : "",
            }
        },

        methods: {
            submitForm(){
                /*
                  Initialize the form data
                */
                let params = {
                    "mediaStructure" : {
                        "model" : this.model,
                        "parent_id" : this.data_parent_folder,
                        "name" :this.data_name_folder,
                        "category" : this.category
                    },
                    "module" : this.module_name,
                    "share" : this.share,
                    "model_id" : this.model_id,


                };

                if(this.method === "put"){
                    /*
                  Make the request to the POST /multiple-files URL
                */
                    axios.put( this.route_form,params).then(function(response){

                        if(response.data.error){

                          Vue.swal.fire(response.data.message);
                          return false;
                        }
                        if(response.data.closePopup){
                            app.__vue__.$refs.vue_popup.active = false;
                            app.__vue__.$refs.vue_sidebar.active = false;
                            app.__vue__.$refs.document_sharing.readFolder(response.data.folder);
                        }
                        else{
                            //add normal file, reload attachment page with url returned from server
                            //console.log("Document normale",response.data);
                            app.__vue__.$refs.vue_popup.toggle("Allegati",response.data.urlHomeAttachments);
                        }
                    })
                        .catch(function(error){
                            if (error.response) {
                                console.log(error.response.data);
                                console.log(error.response.status);
                                console.log(error.response.headers);
                            }
                        })
                        .finally(function (){

                        });

                    //call sync function
                    if(this.share) {
                        app.__vue__.$refs.document_sharing.readFolder(this.folder);
                    }
                }
                else if(this.method === "post"){

                    /*
                  Make the request to the POST /multiple-files URL
                */
                    axios.post( this.route_form,params).then(function(response){

                        if(response.data.error){

                            Vue.swal.fire(response.data.message);
                            return false;
                        }

                        if(response.data.closePopup){
                            app.__vue__.$refs.vue_popup.active = false;
                            app.__vue__.$refs.vue_sidebar.active = false;
                            app.__vue__.$refs.document_sharing.readFolder(response.data.folder);
                        }
                        else{
                            //add normal file, reload attachment page with url returned from server
                            console.log("Document normale",response.data);
                            app.__vue__.$refs.vue_popup.toggle("Allegati",response.data.urlHomeAttachments);
                        }
                    })
                        .catch(function(error){
                            if (error.response) {
                                Vue.swal.fire(error.response.message);
                            }
                        })
                        .finally(function (){

                        });

                }



            },
        },
        props:{

                route_form:{
                    type: String,
                    required : true
                },
                folders_array:{
                    type:Array,
                    required:true
                },
                method:{
                    type: String,
                    required : true
                },
                parent_folder:{
                    type: Number,
                    required : true
                },
                name_folder:{
                    type: String,
                    required : true
                },
                module_name:{
                    type: String,
                    required : true
                },
                model:{
                    type: String,
                    required : true
                },
                category:{
                    type: String,
                    required : false,
                    default : null
                },
                share:{
                    type: Number,
                    required : true
                },
                model_id:{
                    type: Number,
                    required : true
                },

        },


    }
</script>

